import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { dataCatalogSlice, type dataCatalogState } from './dataCatalogSlice'
import { loadingSlice, type loadingState } from './loadingSlice'
import { onBoardingSlice, type onboardingState } from './onBoardingSlice'
import { authSessionSlice, type authSessionState } from './authSessionSlice'
import { graphSlice, type GraphState } from './graphSlice'
import { searchSlice, type SearchState } from './searchSlice'
import { connectorSlice, type ConnectorState } from './connectorCatalogSlice'
import { boardSlice, type BoardSliceState } from './boardSlice'
import { usersSlice, type UsersState } from './usersSlice'
import { sharesSlice, type SharesState } from './sharesSlice'
import { jobSlice, type JobState } from './jobCatalogSlice'
import { modalSlice, type ModalSliceState } from './modalSlice'
import { speechSlice, type SpeechState } from './speechSlice'
import { chatSlice, type ChatState } from './chatSlice'
import { agentPersonasSlice, type AgentPersonasState } from './agentPersonasSlice'
import { commentSlice, type CommentState } from './commentSlice'
import { meetingIntegrationsSlice, type MeetingIntegrationsState } from './meetingIntegrationsSlice'
import { onboardingQuestionsSlice, type OnboardingQuestionsState } from './onboardingQuestionsSlice'
import { inAppMeetingSlice, type InAppMeetingState } from './inAppMeetingSlice'
import { helpAgentSlice, type HelpAgentState } from './helpAgentSlice'
import { featureAccessSlice, type FeatureAccessState } from './featureAccessSlice'

export const useAppStore = create<
  dataCatalogState &
  onboardingState &
  authSessionState &
  GraphState &
  loadingState &
  ConnectorState &
  SearchState &
  BoardSliceState &
  JobState &
  ModalSliceState &
  SpeechState &
  ChatState &
  UsersState &
  SharesState &
  AgentPersonasState &
  CommentState &
  MeetingIntegrationsState &
  OnboardingQuestionsState &
  InAppMeetingState &
  HelpAgentState &
  FeatureAccessState
>()(
  devtools((set, get, api) => ({
    ...dataCatalogSlice(set, get, api),
    ...onBoardingSlice(set, get, api),
    ...authSessionSlice(set, get, api),
    ...loadingSlice(set, get, api),
    ...graphSlice(set, get, api),
    ...connectorSlice(set, get, api),
    ...searchSlice(set),
    ...boardSlice(set, get, api),
    ...jobSlice(set, get, api),
    ...modalSlice(set, get, api),
    ...speechSlice(set, get, api),
    ...chatSlice(set, get, api),
    ...usersSlice(set, get, api),
    ...sharesSlice(set, get, api),
    ...agentPersonasSlice(set, get, api),
    ...commentSlice(set, get, api),
    ...meetingIntegrationsSlice(set, get, api),
    ...onboardingQuestionsSlice(set, get, api),
    ...inAppMeetingSlice(set, get, api),
    ...helpAgentSlice(set, get, api),
    ...featureAccessSlice(set, get, api),
  }))
)
